import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { ARTICLES } from '../constants'
import { ArticleFormInput } from '../types'
import { prepareArticlePayload } from '../utils'

const updateArticle = async ({
  form,
  id,
}: {
  form: ArticleFormInput
  id: number
}) => {
  const formData = prepareArticlePayload(form)

  await fetchAPI({
    method: 'put',
    path: `/articles/${id}`,
    data: formData,
  })
}

export const useUpdateArticle = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(updateArticle, {
    onSuccess: async () => {
      await queryClient.refetchQueries([ARTICLES])

      toast({
        description: t('views.admin.articles.services.update_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
